import type { TagVariant } from "@equiem/react-end-user-ui";

const TAG_TEXT_MAP: Record<string, TagVariant> = {
  "ENDING SOON": "negative",
  "COMING SOON": "positive",
};

export const getAvailabilityBadge = (tagText?: string | null): { variant: TagVariant; label: string } | null => {
  if (tagText == null || tagText === "") {
    return null;
  }

  const variant = TAG_TEXT_MAP[tagText];
  if (variant == null) {
    return null;
  }

  return { variant, label: tagText };
};
